import type { PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import type { PaperProps } from "@mui/material/Paper";
import Paper from "@mui/material/Paper";
import type { SxProps, Theme } from "@mui/material/styles";
import type { TypographyProps } from "@mui/material/Typography";
import Typography from "@mui/material/Typography";

const disabledSx = {
  backgroundColor: "grey.200",
  color: "grey.400",
};

export type CardProps = PropsWithChildren<{
  id?: string;
  title: JSX.Element | string;
  action?: JSX.Element;
  sx?: SxProps<Theme>;
  childrenSx?: SxProps<Theme>;
  dataComponent?: string;
  disabled?: boolean;
  onClick?: PaperProps["onClick"];
  titleAlign?: TypographyProps["align"];
}>;

const Card = ({
  id,
  title,
  children,
  action,
  sx,
  childrenSx,
  dataComponent,
  disabled = false,
  onClick,
  titleAlign,
}: CardProps) => {
  const activeSx = disabled ? disabledSx : {};
  return (
    <Paper id={id} onClick={onClick} sx={{ ...sx, ...activeSx }} data-component={dataComponent}>
      <Box display="flex" justifyContent="space-between" alignItems="center" py={0.5} px={1} minHeight="3rem">
        <Typography flexGrow={1} variant="h2" align={titleAlign ?? undefined}>
          {title}
        </Typography>
        <div>{action}</div>
      </Box>
      <Divider />
      <Box p={1} sx={childrenSx} position="relative">
        {children}
      </Box>
    </Paper>
  );
};

export default Card;
